// Fonte di verità UNICA per lo store_id dell'ordine, condivisa da:
//  - get-shipping-cost (DeliveryForm)
//  - create-checkout  (StripeEmbeddedCheckout)
//  - confirm-cart     (ReviewModal)
// Evita i disallineamenti tra i 3 punti (bug store/totale incoerente).

// Consegna: PV master (get-info), con fallback ai market se non ancora caricato.
export const getDeliveryStoreId = (ecommerceConfig = {}, markets = []) => {
  if (ecommerceConfig.storeIdMaster) return ecommerceConfig.storeIdMaster;
  if (!markets || markets.length === 0) return null;
  const d = markets.find((m) => m.delivery === 1 || m.delivery === true);
  return d ? d.unique_id || d.id : markets[0].unique_id || markets[0].id;
};

// Store per l'ordine in base al metodo scelto.
export const getOrderStoreId = (checkout = {}) => {
  const { deliveryMethod, selectedStore, ecommerceConfig, markets } = checkout;
  if (deliveryMethod === "pickup") {
    return selectedStore ? selectedStore.unique_id || selectedStore.id : null;
  }
  return getDeliveryStoreId(ecommerceConfig, markets);
};

// Slot payload per create-checkout e confirm-cart. get-slots restituisce gli
// orari come "HH:MM:SS", ma il backend costruisce delivery_datetime appendendo
// ":00" (secondi) aspettandosi "HH:MM": inoltrare "HH:MM:SS" grezzo produce
// "HH:MM:SS:00" -> datetime invalido, INSERT KO (SQLSTATE 22007). Normalizziamo
// a "HH:MM" così l'append dà "HH:MM:00" valido (e MySQL accetta "HH:MM" comunque).
const toHourMinute = (t) => (typeof t === "string" ? t.substring(0, 5) : t);

export const buildSlotPayload = (selectedSlot) =>
  selectedSlot
    ? {
        time_from: toHourMinute(selectedSlot.time_from),
        time_to: toHourMinute(selectedSlot.time_to),
      }
    : null;
